<template>
	<div class="user-assign-select__footer" :class="classAddons">
		<template v-if="hasActiveRoleFilter">
			<SuiButton
				class="user-assign-select__footer-button"
				@click="$emit('remove-role')"
			>
				{{ $t('user_assign_select_unassign_role') }}
			</SuiButton>
		</template>
		<template v-else>
			<div v-if="taskId" class="user-assign-select__notify-checkbox">
				<SuiCheckbox
					:model-value="shouldNotify"
					@update:model-value="$emit('update:should-notify', $event)"
				>
					{{ $t('notify') }}
				</SuiCheckbox>
			</div>
			<SuiButton variant="primary" @click="$emit('assign-users')">
				{{ $t('apply') }}
			</SuiButton>
		</template>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { SuiCheckbox, SuiButton } from '@developers/scoro-ui';
import type { Task } from '@/generated/graphql';
import type { UserAssignSelectRole } from '../../types';

export interface UserAssignSelectFooterProps {
	taskId?: Task['id'];
	shouldNotify: boolean;
	activeRoleFilterId: UserAssignSelectRole['id'] | null;
}

const props = defineProps<UserAssignSelectFooterProps>();

const hasActiveRoleFilter = computed(() => props.activeRoleFilterId !== null);

const classAddons = computed(() => ({
	'user-assign-select__footer--with-notify':
		props.taskId && !hasActiveRoleFilter.value,
}));

defineEmits<{
	'update:should-notify': [value: boolean];
	'assign-users': [];
	'remove-role': [];
}>();
</script>

<style lang="scss" scoped>
.user-assign-select {
	&__footer-button {
		--sui-button-background-color: #{$red-10};
		--sui-button-hover-background-color: #{$red-20};

		color: #{$red-90};
	}
}
</style>
